import { NumberFormatterAdapter } from "./NumberFormatter.adapter";

export class NumberCheckAdapter {
  private readonly numberFormatterAdapter = new NumberFormatterAdapter();

  isNumber(value: string): boolean {
    if (value === null || value === undefined || value === "") {
      return false;
    }
    return !Number.isNaN(Number(value));
  }

  isValidNumber(str: string) {
    if (typeof str !== "string") return false;

    const num = this.numberFormatterAdapter.parseFormattedNumber(str);

    return str !== "" && num != null && !Number.isNaN(num);
  }

  isNumberWithDecimal(value: string | number): boolean {
    return !Number.isNaN(Number(value)) && value.toString().includes(".");
  }

  isPositiveNumber(value: string | number): boolean {
    if (typeof value === "string") {
      return this.isValidNumber(value) && (this.numberFormatterAdapter.parseFormattedNumber(value) ?? 0) > 0;
    }
    return value > 0;
  }

  isNegativeNumber(value: string | number): boolean {
    if (typeof value === "string") {
      return this.isValidNumber(value) && (this.numberFormatterAdapter.parseFormattedNumber(value) ?? 0) < 0;
    }
    return value < 0;
  }

  isAllNumberPositive(value: string[] | number[]): boolean {
    return value.every(value => this.isPositiveNumber(value));
  }

  isAllNumberNegative(value: string[] | number[]): boolean {
    return value.every(value => this.isNegativeNumber(value));
  }

  isNumberMaxNumber(value: string | number, max: number): boolean {
    if (typeof value === "string") {
      return this.isValidNumber(value) && (this.numberFormatterAdapter.parseFormattedNumber(value) ?? 0) <= max;
    }
    return value <= max;
  }

  isNumberMinNumber(value: string | number, min: number): boolean {
    if (typeof value === "string") {
      return this.isValidNumber(value) && (this.numberFormatterAdapter.parseFormattedNumber(value) ?? 0) >= min;
    }
    return value >= min;
  }

  isNumberBetween(value: string | number, min: number, max: number): boolean {
    if (typeof value === "string") {
      return (
        this.isValidNumber(value) &&
        (this.numberFormatterAdapter.parseFormattedNumber(value) ?? 0) >= min &&
        (this.numberFormatterAdapter.parseFormattedNumber(value) ?? 0) <= max
      );
    }
    return value >= min && value <= max;
  }
}
